<script>
  import { Globe, Plus, Search, SquareCode } from 'lucide-svelte';

  export let menus = [];
  export let filteredMenus = [];
  export let searchQuery = '';
  export let selectedMenuId = null;
  export let onNewMenu = () => {};
  export let onSelectMenu = () => {};
</script>

<aside class="min-w-0 rounded-xl border border-slate-200 bg-white shadow-sm">
  <div class="border-b border-slate-200 px-4 py-4">
    <div class="mb-3 flex items-start justify-between gap-3">
      <div class="min-w-0">
        <h2 class="text-base font-semibold text-slate-900">Menu Management</h2>
        <p class="mt-0.5 text-xs text-slate-500">{menus.length} menus</p>
      </div>

      <button
        type="button"
        class="inline-flex h-9 shrink-0 items-center gap-2 rounded-xl bg-blue-600 px-3 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-100"
        on:click={onNewMenu}>
        <Plus size={16} />
        New
      </button>
    </div>

    <div class="relative">
      <Search size={15} class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
      <input
        bind:value={searchQuery}
        placeholder="Search menu..."
        class="h-10 w-full rounded-xl border border-slate-300 bg-white pl-9 pr-3 text-sm text-slate-700 shadow-sm outline-none placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100" />
    </div>
  </div>

  <div class="max-h-[420px] space-y-1 overflow-auto p-2 lg:max-h-none">
    {#if filteredMenus.length}
      {#each filteredMenus as menu}
        <button
          type="button"
          class="flex w-full min-w-0 items-center gap-3 rounded-xl border px-3 py-3 text-left transition {menu.id === selectedMenuId
            ? 'border-blue-200 bg-blue-50 shadow-sm'
            : 'border-transparent hover:border-slate-200 hover:bg-slate-50'}"
          on:click={() => onSelectMenu(menu)}>
          <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white">
            {#if menu.menu_type === 'component'}
              <SquareCode size={18} class="text-blue-600" />
            {:else if menu.menu_type === 'iframe'}
              <Globe size={18} class="text-emerald-600" />
            {/if}
          </span>

          <span class="min-w-0 flex-1">
            <span class="block truncate text-sm font-semibold text-slate-900">{menu.label}</span>
            <span class="block truncate text-xs text-slate-500">{menu.code}</span>
          </span>
        </button>
      {/each}
    {:else}
      <div class="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-8 text-center text-sm text-slate-500">
        No menus found
      </div>
    {/if}
  </div>
</aside>
